(function() {
  App.params = function() {
    return new URLSearchParams(window.location.search);
  };

  App.get_param = function(param_name) {
    return App.params().get(param_name);
  };

  App.set_param = function(param_name, param_value) {
    var search_params = App.params();
    search_params.set(param_name, param_value);
    if (!!param_value) {
      if (window.location.search != search_params.toString()) {
        window.location.search = search_params.toString();
      }
    } else {
      App.clear_param(param_name);
    }
  };

  App.clear_param = function(param_name) {
    var search_params = App.params();
    search_params.delete(param_name);
    if (window.location.search != search_params.toString()) {
      window.location.search = search_params.toString();
    }
  };
}.call(this));
